/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseCategoryDto } from './CaseCategoryDto';
import {
    CaseCategoryDtoFromJSON,
    CaseCategoryDtoFromJSONTyped,
    CaseCategoryDtoToJSON,
    CaseCategoryDtoToJSONTyped,
} from './CaseCategoryDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface CaseCategoryListResponse
 */
export interface CaseCategoryListResponse {
    /**
     * 
     * @type {string}
     * @memberof CaseCategoryListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof CaseCategoryListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof CaseCategoryListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof CaseCategoryListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {Array<CaseCategoryDto>}
     * @memberof CaseCategoryListResponse
     */
    data?: Array<CaseCategoryDto>;
}

/**
 * Check if a given object implements the CaseCategoryListResponse interface.
 */
export function instanceOfCaseCategoryListResponse(value: object): value is CaseCategoryListResponse {
    return true;
}

export function CaseCategoryListResponseFromJSON(json: any): CaseCategoryListResponse {
    return CaseCategoryListResponseFromJSONTyped(json, false);
}

export function CaseCategoryListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseCategoryListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CaseCategoryDtoFromJSON)),
    };
}

export function CaseCategoryListResponseToJSON(json: any): CaseCategoryListResponse {
    return CaseCategoryListResponseToJSONTyped(json, false);
}

export function CaseCategoryListResponseToJSONTyped(value?: CaseCategoryListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CaseCategoryDtoToJSON)),
    };
}

